import { styled } from '@mui/material/styles'

export const AnswerLegendText = styled('span')<any>({
  fontFamily: 'Zen Kaku Gothic Antique',
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '17px',
  color: '#525252',
})
